import React from 'react'
import './VideoLoginUser.css';
import { useNavigate } from 'react-router-dom';

function VideoLoginUser () {
  const navigate = useNavigate();

  const handleReset = () => {
    navigate("/signin");
  };

  return (
    <div className='video-subscription-container'>
        <div className='video-subscription-content'>
            <h3>Sign in to your account to start learning</h3>
            <p>Subscribe to our video content and enjoy unlimited access to a wide range of educational videos.</p>
            <button className='subscribe-button' onClick={handleReset}>Get start with classes</button>
        </div>
    </div>
  )
}

export default VideoLoginUser